// src/AdminDashboard/components/MultiStepGameForm/GamePreview/GameboardPreview.js
import React from "react";
import Logo from "../../../../Logo";
import { getSelectedLogoUrl } from "../../../../Logo";

const GameboardPreview = ({ formData, dynamicStyles, client }) => {
  const isMemory = formData.type === "memory";
  const memoryPairs = Array.isArray(formData?.gameData?.pairs)
    ? formData.gameData.pairs
    : [];
  const allCards = isMemory
    ? memoryPairs.flatMap((pair, index) => [
        {
          key: `${pair?.id || `pair-${index + 1}`}-a`,
          imageUrl: pair?.imageUrl || "",
          isFaceUp: index < 2,
        },
        {
          key: `${pair?.id || `pair-${index + 1}`}-b`,
          imageUrl: pair?.imageUrl || "",
          isFaceUp: index < 2,
        },
      ])
    : Object.values(formData.gameData || {})
        .flat()
        .map((word, index) => ({
          key: `conn-${index}`,
          word,
        }));
  const timerSeconds = formData?.gameData?.settings?.timerSeconds;
  const hasTimer = timerSeconds !== null && timerSeconds !== undefined;
  const cardBackImageUrl = formData?.gameData?.settings?.cardBackImageUrl || "";
  const showMatchSuccessPopup = Boolean(
    formData?.gameData?.settings?.showMatchSuccessPopup
  );
  const firstPairWithDescription = memoryPairs.find((pair) =>
    String(pair?.description || pair?.message || "").trim()
  );
  const firstPairDescription =
    firstPairWithDescription?.description ||
    firstPairWithDescription?.message ||
    "";
  const memoryMatchSuccessMessage =
    formData?.gameData?.settings?.memoryMatchSuccessMessage || "Great match!";
  const previewPopupCopy = [memoryMatchSuccessMessage, firstPairDescription]
    .filter((line) => String(line || "").trim())
    .join("\n\n");

  const selectedLogoUrl = getSelectedLogoUrl(client, formData?.reveal);

  return (
    <div className="gameboard-preview" style={dynamicStyles}>
      <div className="preview-logo">
        <Logo client={client} logoUrl={selectedLogoUrl} />
      </div>
      {isMemory ? (
        <div className="preview-memory-hud">
          {hasTimer ? (
            <div className="preview-memory-countdown">
              {`${Number(timerSeconds)}s`}
            </div>
          ) : null}
          <div>{`Pairs Matched: 0/${memoryPairs.length}`}</div>
        </div>
      ) : null}

      <div className="game-message">
        {isMemory
          ? "Match all image pairs before time runs out."
          : "Find groups of four words that share a connection."}
      </div>
      {isMemory && showMatchSuccessPopup ? (
        <div className="preview-memory-success-popup">
          {previewPopupCopy || "Great match!"}
        </div>
      ) : null}

      <div className="cards-grid">
        {allCards.map((card, index) => (
          <div
            key={card.key || index}
            className={`${isMemory ? "memory-card" : "card"} ${
              isMemory && card.isFaceUp ? "face-up" : ""
            }`}
            style={
              isMemory && !card.isFaceUp
                ? {
                    backgroundImage: cardBackImageUrl
                      ? `url(${cardBackImageUrl})`
                      : undefined,
                    backgroundColor: formData.cardBackgroundColor || undefined,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }
                : undefined
            }
          >
            <div
              className="card-text"
              style={
                isMemory && card.isFaceUp
                  ? {
                      backgroundImage: card.imageUrl
                        ? `url(${card.imageUrl})`
                        : undefined,
                    }
                  : undefined
              }
            >
              {isMemory
                ? card.isFaceUp
                  ? ""
                  : ""
                : card.word || `Card ${index + 1}`}
            </div>
          </div>
        ))}
      </div>

      {isMemory ? null : (
        <div className="action-buttons">
          <button className="deselect-button">DESELECT ALL</button>
          <button className="submit-button">SUBMIT</button>
        </div>
      )}
    </div>
  );
};

export default GameboardPreview;
